<section class="privacy-policy">
    <div class="container">

        <h2>Polityka Prywatności</h2>

        <h3>Informacje ogólne</h3>
        <p>
            Niniejsza Polityka Prywatności opisuje zasady przetwarzania danych osobowych Użytkowników w związku z
            korzystaniem z serwisu Juno Audit dostępnego pod domeną
            <a href="https://junoaudit.pl" target="_blank" rel="noopener">https://junoaudit.pl</a>.
        </p>
        <p>
            Administratorem danych osobowych jest:
        </p>
        <ul>
            <li>
                <strong>DEVAN, Paweł Długoszek</strong>, z siedzibą w Warszawie, ul. Herbu Oksza 4/91, 02-495 Warszawa,
                NIP: 5261132186, REGON: 141271557
            </li>
        </ul>
        <p>
            (dalej zwany: „Administrator”).
        </p>
        <p>
            W sprawach związanych z przetwarzaniem danych osobowych można się kontaktować pod adresem e-mail:
            <a href="mailto:kontakt&#64;junoaudit.pl">kontakt&#64;junoaudit.pl</a>.
        </p>

        <h3>Zakres przetwarzanych danych</h3>
        <p>Serwis Juno Audit przetwarza jedynie minimalny zakres danych osobowych:</p>
        <ul>
            <li>
                <strong>Adres e-mail</strong> – w celu kontaktu z Użytkownikami, którzy dobrowolnie przekazali swój
                e-mail w kontekście:
                <ul>
                    <li>zgłoszenia chęci współpracy,</li>
                    <li>zainteresowania wersją beta systemu Juno Audit.</li>
                    <li>Podany adres e-mail jest wykorzystywany wyłącznie w celu nawiązania kontaktu w sprawach
                        związanych z ofertą współpracy lub uzyskania dostępu
                        do wersji beta systemu. Nie wykorzystujemy go w celach marketingowych ani nie przesyłamy
                        niezamówionych treści reklamowych.Adres e-mail jest
                        przechowywany w naszej zabezpieczonej bazie danych i może zostać usunięty na żądanie poprzez
                        kontakt na adres <a href="mailto:kontakt&#64;junoaudit.pl">kontakt&#64;junoaudit.pl</a></li>
                </ul>
            </li>
            <li>
                <strong>Adres IP</strong> – zapisywany automatycznie w celach:
                <ul>
                    <li>zapewnienia bezpieczeństwa (np. ochrona przed atakami typu brute force lub spamem),</li>
                    <li>wykrywania i zapobiegania nadużyciom (np. automatyczne boty wysyłające żądania),</li>
                    <li>analizy błędów technicznych i diagnostyki działania systemu,</li>
                    <li>realizacji limitów żądań (rate limiting) i statystyk technicznych.</li>
                </ul>
            </li>
        </ul>
        <p>
            Gromadzenie adresu IP jest standardową praktyką stosowaną przez większość serwisów internetowych i nie służy
            do identyfikowania konkretnych osób, chyba że użytkownik sam poda dodatkowe dane (np. e-mail).
        </p>
        <p>Nie gromadzimy żadnych innych danych identyfikujących użytkownika poza powyższymi.
            Serwis nie zbiera danych wrażliwych, takich jak dane dotyczące zdrowia, przekonań religijnych, orientacji
            seksualnej itp.</p>

        <h3>Podstawy prawne przetwarzania</h3>
        <ul>
            <li><strong>art. 6 ust. 1 lit. a RODO</strong> – zgoda osoby, której dane dotyczą – np. podanie adresu
                e-mail w formularzu kontaktowym lub przy zapisie na wersję beta,</li>
            <li><strong>art. 6 ust. 1 lit. f RODO</strong> – prawnie uzasadniony interes Administratora, jakim jest
                zapewnienie bezpieczeństwa działania serwisu, zapobieganie nadużyciom i analiza działania systemu (np.
                zapisywanie adresów IP),</li>
            <li>wypełnienia obowiązków wynikających z przepisów prawa – jeśli takie wystąpią.</li>
        </ul>

        <h3>Pliki cookies</h3>
        <p>
            Serwis może wykorzystywać pliki cookies w celach technicznych oraz statystycznych. Użytkownik może w każdej
            chwili zmienić ustawienia swojej przeglądarki dotyczące plików cookies.
        </p>

        <h3>Bezpieczeństwo danych</h3>
        <ul>
            <li>Wdrożono odpowiednie środki organizacyjne i techniczne w celu ochrony danych przed dostępem osób
                nieuprawnionych. Dane nie są sprzedawane ani udostępniane podmiotom trzecim.
            </li>
            <li>Serwis jest zabezpieczony certyfikatem SSL, co zapewnia szyfrowanie przesyłanych danych.</li>
            <li>Przechowywanie danych odbywa się na serwerach zlokalizowanych w Unii Europejskiej, zgodnie z
                przepisami RODO.</li>
        </ul>

        <h3>Prawa użytkownika</h3>
        <p>Każdej osobie, której dane dotyczą, przysługują następujące prawa:</p>
        <ul>
            <li>prawo dostępu do swoich danych – <strong>art. 15 RODO</strong>,</li>
            <li>prawo do sprostowania danych – <strong>art. 16 RODO</strong>,</li>
            <li>prawo do usunięcia danych („prawo do bycia zapomnianym”) – <strong>art. 17 RODO</strong>,</li>
            <li>prawo do ograniczenia przetwarzania – <strong>art. 18 RODO</strong>,</li>
            <li>prawo do wycofania zgody w dowolnym momencie – <strong>art. 7 ust. 3 RODO</strong> (nie wpływa to na
                zgodność z prawem przetwarzania przed jej wycofaniem),</li>
            <li>prawo do wniesienia skargi do organu nadzorczego – Prezesa Urzędu Ochrony Danych Osobowych (PUODO).</li>
        </ul>

        <h3>Zmiany polityki</h3>
        <p>
            Zastrzegamy sobie prawo do wprowadzenia zmian w niniejszej Polityce Prywatności, wynikających np. z rozwoju
            serwisu, zmiany przepisów prawa lub technologii. Aktualna wersja Polityki będzie zawsze dostępna na stronie
            serwisu.
        </p>

        <p><em>Data ostatniej aktualizacji: 30 lipca 2025</em></p>
    </div>
</section>